import { action } from 'easy-peasy'

export const createUIModel = () => ({
	sectionHeights: {},
	setSectionHeight: action((state, { name, value }) => {
		state.sectionHeights[name] = value
	}),
})
